import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection';
import './PhotoSection.scss';
import churchPhoto from '../../assets/images/church/photo-hero.jpg';

const PhotoSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const blurReveal = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0, filter: 'blur(6px)' },
              whileInView: { opacity: 1, filter: 'blur(0px)' },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.4, ease: 'easeOut' },
          };

    const fadeIn = prefersReducedMotion
        ? {}
        : {
              initial: { opacity: 0 },
              whileInView: { opacity: 1 },
              viewport: { once: true, amount: 0.25 },
              transition: { duration: 1.0, delay: 0.5, ease: EASE_OUT_EXPO },
          };

    return (
        <section className="photo-section" aria-label="Scripture quote">
            <img
                src={churchPhoto}
                alt=""
                className="photo-section__img"
                loading="lazy"
            />
            <div className="photo-section__overlay">
                <div className="photo-section__content">
                    <motion.blockquote className="photo-section__quote" {...blurReveal}>
                        {t('photo_quote')}
                        <motion.cite className="photo-section__attribution" {...fadeIn}>
                            {t('photo_attribution')}
                        </motion.cite>
                    </motion.blockquote>
                </div>
            </div>
        </section>
    );
};

export default PhotoSection;
